import { noop } from "@tanstack/react-query"
import { createFileRoute } from "@tanstack/react-router"

import { $rqIotApiClient } from "@/api/iot"
import { routeGuard } from "@/lib/routing/beforeLoad"

export const Route = createFileRoute("/_authlayout/_sidebar/api-keys/")({
  beforeLoad: async ({ context }) => {
    await routeGuard(context)
  },
  loader: ({ context: { queryClient } }) => {
    queryClient.query($rqIotApiClient.queryOptions("get", "/iot/v1/clients")).catch(noop)
  },
  head: () => ({
    meta: [
      {
        title: "API Keys | Arduino Cloud"
      }
    ]
  })
})
